<template>
  <div :class="$modal.modalContentContainer">
    <div :class="$modal.modalContent">
      <v-flex>
        <p :class="$modal.modalText">
          Please select one of the options below:
        </p>
      </v-flex>
      <v-flex :class="$style.modalButtons">
        <BaseButton :class="$style.modalBtn"
                    button-style="Main"
                    @click="handleCreateAccount">
          Create Account
        </BaseButton>
        <BaseButton v-if="showGuestButton"
                    :class="$style.modalBtn"
                    button-style="Main"
                    @click="handleGuestCheckout">
          Guest Checkout
        </BaseButton>
      </v-flex>
      <v-flex :class="$modal.fullWidth">
        <p :class="$style.centeredTitle">
          <span>Or</span>
        </p>
      </v-flex>
      <v-flex :class="$modal.signIn">
        <p>Already have an account?</p>
        <button @click="handleSighIn">Sign In</button>
      </v-flex>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import BaseButton from '@/components/BaseButton';

/**
 * Form to check if phone number exists. On success will store pone data in
 * vuex store for further use.
 *
 * EVENTS:
 *  create-account - When user clicked on "Create account" button
 *  guest-checkout - When user clicked on "Guest Checkout" button
 *  sign-in - When user clicked on "Sign In" button
 */
@Component({
  components: {
    BaseButton,
  },
  props: {
    showGuestButton: {
      type:    Boolean,
      default: true,
    },
  },
})
export default class CheckoutModal extends Vue {
  /**
   * Click on "Create account" button
   */
  handleCreateAccount() {
    this.$emit('create-account');
  }

  /**
   * Click on "Guest Checkout" button
   */
  handleGuestCheckout() {
    this.$emit('guest-checkout');
  }

  /**
   * Click on "Sign In" button
   */
  handleSighIn() {
    this.$emit('sign-in');
  }
}
</script>

<style src="@/style/modals.scss" lang="scss" module="$modal"></style>

<style lang="scss" module>
@import "~@/style/variables.scss";

.modalButtons {
  display: flex;
  width: 100%;
  margin-bottom: 25px;
}

.modalButtons .modalBtn {
  width: auto;
  flex: auto;
  padding: 26px;
  margin: 0 10px;
}

.centeredTitle {
  overflow: hidden;
  text-align: center;
  position: relative;
  margin: 0 28px 32px;

  span {
    font-size: 15px;
    font-weight: 500;
    text-transform: uppercase;
    background-color: $white;
    padding: 0 8px;
    position: relative;
    z-index: 10;
  }

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: $green-color;
    left: 0;
    top: calc(50% - 1px);
  }
}

@media screen and (max-width: 767px) {
  .modalButtons .modalBtn {;
    padding: 16px;

    div {
      font-size: 14px;
      line-height: 14px;
    }
  }
}

@media screen and (max-width: 520px) {
  .modalButtons {
    flex-direction: column;
    align-items: center;
  }
  .modalButtons .modalBtn {
    width: calc(100% - 40px);
    margin: 0 20px 14px;
  }
  .centeredTitle {
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 360px) {
  .modalButtons .modalBtn {
    width: 100%;
    margin: 0 0 14px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/CheckoutModal.vue